import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import getPVDataList from "../http/getPVDataList";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const usePvData = (isProd: boolean = true) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);
  const fetchPVData = useQuery(
    ["pvDataList"],
    async () => {
      return getPVDataList(await getAuthTokenBlocking(getToken, relogin));
    },
    {
      enabled: isProd,
    }
  );

  return {
    fetchPVData,
  };
};

export default usePvData;
